import { render, staticRenderFns } from "./roleAdmin.vue?vue&type=template&id=44fa9b21&scoped=true"
import script from "./roleAdmin.vue?vue&type=script&lang=js"
export * from "./roleAdmin.vue?vue&type=script&lang=js"
import style0 from "./roleAdmin.vue?vue&type=style&index=0&id=44fa9b21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa9b21",
  null
  
)

export default component.exports